import { render, staticRenderFns } from "./SearchedList.vue?vue&type=template&id=571c89e0&scoped=true&"
import script from "./SearchedList.vue?vue&type=script&lang=js&"
export * from "./SearchedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571c89e0",
  null
  
)

export default component.exports